import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputLabel,
  Stack,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";

import { useState } from "react";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import { DataGrid } from "@mui/x-data-grid";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import NoDataFound from "../CustomComponents/NoDataFound";
import { makeStyles } from "@mui/styles";
import { useEffect } from "react";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import store from "../Store";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import { Delete } from "@mui/icons-material";
import CustomTextField from "../CustomComponents/CustomTextField";
import axios from "axios";
import { useValidation } from "../Hook/useValidation";
import dayjs from "dayjs";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles({
  dataGridContainer: {
    cursor: "pointer",
  },
});
const FeeRateDefinition = () => {
  //State Which Maintain Filter values
  const [userName, setUserName] = useState("");
  const [feeList, setFeeList] = useState([]);
  const [applicationTypeList, setapplicationTypeList] = useState([
    "HOMFINSYS",
    "ST LAP",
    "New App",
  ]);
  const {
    stateValue: applicationType,
    setStateValue: setApplicationType,
    setTouchHandler: setApplicationTypeTouchHandler,
    valueIsValid: applicationTypeIsValid,
    valueHasError: applicationTypeHasError,
  } = useValidation(
    "",
    false,
    (value) => value !== null && value !== undefined && value !== ""
  );
  const {
    stateValue: effectiveDateValue,
    setStateValue: setEffectiveDateValue,
    setTouchHandler: setEffectiveTouchHandler,
    valueIsValid: effectiveDateIsValid,
    valueHasError: effectiveDateHasError,
  } = useValidation(
    null,
    false,
    (value) => value !== null && value !== undefined
  );
  const {
    stateValue: feeValue,
    setStateValue: setFeeValue,
    setTouchHandler: setFeeTouchHandler,
    valueIsValid: feeIsValid,
    valueHasError: feeValueHasError,
  } = useValidation(
    "",
    false,
    (value) => value !== null && value !== undefined && value !== ""
  );

  const {
    stateValue: productValue,
    setStateValue: setProductValue,
    setTouchHandler: setProductTouchHandler,
    valueIsValid: productValueIsValid,
    valueHasError: productHasError,
  } = useValidation(
    "",
    false,
    (value) => value !== null && value !== undefined && value !== ""
  );
  const {
    stateValue: constitutionType,
    setStateValue: setConstitutionType,
    setTouchHandler: setConstitutionTouchHandler,
    valueIsValid: constitutionTypeHasErrorIsValid,
    valueHasError: constitutionTypeHasError,
  } = useValidation(
    "",
    false,
    (value) => value !== null && value !== undefined && value !== ""
  );
  //Product State
  const [productList, setProductList] = useState(["Housing", "Non-Housing"]);
  //State which maintain read only properties value
  const [proposalType, setProposalType] = useState("");
  const [loanType, setLoanType] = useState("");

  const [profile, setProfile] = useState("");

  const [purposeofLoan, setPurposeofLoan] = useState("");

  const [lifeCoverApplicability, setLifeCoverApplicability] = useState("");

  const [rateType, setRateType] = useState("");

  const [borrowerCategory, setBorrowerCategory] = useState("");

  const [loanCategory, setLoanCategory] = useState("");

  const [propertyCategory, setPropertyCategory] = useState("");
  const [type, setType] = useState("");
  const [feeDescription, setFeeDescription] = useState("");
  const [gl, setGl] = useState("");
  const [subGL, setSubGL] = useState("");

  //State which maintain branch Dialogues
  const [branchDialogOpen, setBranchDialogOpen] = useState(null);
  const [datarowsBranch, setDatarowsBranch] = useState([]);
  const columnsBranch = [
    {
      field: "branch_name",
      headerName: "Branch",
      headerAlign: "center",
      align: "left",
      flex: 350,
      type: "string",
      editable: false,
    },
  ];

  const [selectedRow, setSelectedRow] = useState([]);
  const [selectedBranchRows, setSelectedBranchRows] = useState([]);
  const [columnsBranchData, setBranchColumns] = useState(columnsBranch);
  const [branchTouchHandler, setBranchTouchHandler] = useState(false);
  const branchIsValid = selectedRow.length > 0;
  const branchHasError = branchTouchHandler && !branchIsValid;
  let activeRowID = [];

  //fieldaccess
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  const dispatch = useDispatch();

  useEffect(() => {
    getFieldData();
  }, []);
  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateFromValue = Number(0);
  let maxDateFromValue = Number(0);
  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Fee Rate Defintion Date Back Count"] &&
        new Date(
          paramValues["Fee Rate Defintion Date Back Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Fee Rate Defintion Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateFromValue = 0;
    } else {
      minDateFromValue =
        fieldAccessMap.feeRateDefinitionEffectiveDate &&
        fieldAccessMap.feeRateDefinitionEffectiveDateBackCount
          ? Number(
              paramValues["Fee Rate Defintion Date Back Count"]["paramValue"]
            )
          : Number(0);
    }
    if (
      !(
        paramValues["Fee Rate Defintion Date Future Count"] &&
        new Date(
          paramValues["Fee Rate Defintion Date Future Count"][
            "paramEffStartDate"
          ]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Fee Rate Defintion Date Future Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateFromValue = 0;
    } else {
      maxDateFromValue =
        fieldAccessMap.feeRateDefinitionEffectiveDate &&
        fieldAccessMap.feeRateDefinitionEffectiveDateFutureCount
          ? Number(
              paramValues["Fee Rate Defintion Date Future Count"]["paramValue"]
            )
          : Number(0);
    }
  }

  //Methods
  const effectiveDateOnChangeHandler = (value) => {
    setEffectiveDateValue(value);
  };
  const feeTypeOnChangeHandler = (value) => {
    setFeeValue(value);
    getGridData(value);
  };
  const branchOnChangeHandler = () => {
    setBranchDialogOpen(true);
    setBranchTouchHandler(true);
  };
  const productOnChangeHandler = (value) => {
    setProductValue(value);
  };
  const goButtonHandler = () => {
    setApplicationTypeTouchHandler(true);
    setEffectiveTouchHandler(true);
    setFeeTouchHandler(true);
    setProductTouchHandler(true);
    setConstitutionTouchHandler(true);
    setBranchTouchHandler(true);
    if (
      applicationTypeIsValid &&
      effectiveDateIsValid &&
      feeIsValid &&
      productValueIsValid &&
      constitutionTypeHasErrorIsValid
    ) {
      setDisplayDetail(true);
    }
  };
  const ClearButtonHandler = () => {
    setSelectedBranchRows([]);
    setDisplayDetail(false);
    setFeeValue("");
    setEffectiveDateValue(null);
    setBranchTouchHandler(false);
    setFeeTouchHandler(false);
    setEffectiveTouchHandler(false);
    setSelectedRow([]);
  };
  const NoRowsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <NoDataFound message="No Data." />
      </Stack>
    );
  };

  const NoResultsOverlay = () => {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <NoDataFound message="No Data on Applied Filter." />
      </Stack>
    );
  };

  const classes = useStyles();
  useEffect(() => {
    const users = store.getState().branch.userName;
    setUserName(users);
    const branchValues = GetBranchDetails();
    const branchArrayList = branchValues.map((branch, index) => {
      return {
        id: index,
        branch_name: branch.label,
      };
    });
    setDatarowsBranch(branchArrayList);
  }, []);
  // State which used to maintain detail screens
  const [displayDetail, setDisplayDetail] = useState(false);
  const [rows, setRows] = useState([]);
  const [percentageEnable, setPercentageEnable] = useState(null);
  const [flatEnable, setFlatEnable] = useState(null);
  //Dialog state
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [confirmationDialogMessage, setConfirmationDialogMessage] = useState();
  const [confirmationDialogMode, setConfirmationDialogMode] = useState(null);
  const columnsData = [
    {
      field: "fromAmt",
      headerName: "From Amount (₹)",
      headerAlign: "center",
      flex: 280,
      type: "number",
      align: "right",
      renderCell: (params) => {
        return parseInt(params.value).toLocaleString("en-IN");
      },
    },
    {
      field: "toAmt",
      headerName: "To Amount (₹)",
      headerAlign: "center",
      align: "right",
      editable: true,
      type: "number",
      flex: 280,
      renderCell: (params) => {
        return params.value !== "" && params.value !== null
          ? parseInt(params.value).toLocaleString("en-IN")
          : params.value;
      },
    },
    {
      field: "percentage",
      headerName: "Percentage (%)",
      headerAlign: "center",
      flex: 260,
      align: "right",
      type: "number",
      editable: percentageEnable,
    },

    {
      field: "flatRate",
      headerName: "Flat Rate",
      headerAlign: "center",
      align: "right",
      flex: 232,
      editable: flatEnable,
      type: "number",
      renderCell: (params) => {
        return params.value !== "" && params.value !== null
          ? parseInt(params.value).toLocaleString("en-IN")
          : "";
      },
    },
    {
      field: "minimumAmount",
      headerName: "Minimum Amount",
      headerAlign: "center",
      align: "right",
      flex: 232,
      type: "number",
      editable: true,
      renderCell: (params) => {
        return params.value !== "" && params.value !== null
          ? parseInt(params.value).toLocaleString("en-IN")
          : "";
      },
    },

    {
      field: "icon",
      headerName: "",
      headerAlign: "center",
      align: "left",
      flex: 25,
      type: "number",
      disableColumnMenu: true,
      sortable: false,

      renderCell: (params) => {
        return (
          <Tooltip title="Delete">
            <Delete
              onClick={() => {
                deleteSelectedRow(params);
              }}
            ></Delete>
          </Tooltip>
        );
      },
    },
  ];

  const gridRowAddButtonHandler = () => {
    if (rows.length === 0) {
      let newRow = {
        id: 0,
        fromAmt: 0,
        toAmt: 0,
        percentage: "",
        flatRate: "",
        minimumAmount: "",
        flag: false,
      };
      setRows((prevRows) => [...prevRows, newRow]);
    } else {
      if (
        rows[rows.length - 1]["toAmt"].toString() &&
        rows[rows.length - 1]["toAmt"] > 0 &&
        rows[rows.length - 1]["fromAmt"].toString()
      ) {
        let newRow = {
          id: rows.length,
          fromAmt: !rows[rows.length - 1]
            ? 0
            : rows[rows.length - 1]["toAmt"] + 1,
          toAmt: 0,
          percentage: "",
          flatRate: "",
          minimumAmount: "",
          flag: false,
        };
        setRows((prevRows) => [...prevRows, newRow]);
      }
    }
  };

  const cellChangeHandler = (params) => {
    const dataIndex = rows.findIndex((data) => {
      return data.id === params.id;
    });
    if (params.field === "percentage") {
      if (params.value > 99.99 || params.value < 0) {
        let data = rows[dataIndex];
        const datas = { ...data, percentage: 0 };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      } else {
        let data = rows[dataIndex];
        const datas = { ...data, percentage: params.value };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      }
    } else if (params.field === "flatRate") {
      if (params.value > 999999 || params.value < 0) {
        let data = rows[dataIndex];
        const datas = { ...data, flatRate: 0 };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      } else {
        let data = rows[dataIndex];
        const datas = { ...data, flatRate: params.value };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      }
    } else if (params.field === "toAmt") {
      if (params.value > 999999 || params.value < 0) {
        let data = rows[dataIndex];
        const datas = { ...data, toAmt: 0 };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      } else {
        let data = rows[dataIndex];
        const datas = { ...data, toAmt: params.value };
        let newItem = [...rows];
        newItem[dataIndex] = datas;
        setRows(newItem);
      }
    } else {
      let data = rows[dataIndex];
      const datas = { ...data, [params.field]: params.value };
      let newItem = [...rows];
      newItem[dataIndex] = datas;
      setRows(newItem);
    }
  };
  const doCheckIsDataValidated = () => {
    let saveFlag = true;
    let lastReceiptAmount = 0;
    rows.forEach((value, index) => {
      if (
        lastReceiptAmount <= value["fromAmt"] &&
        value["fromAmt"] < value["toAmt"] &&
        (value["flatRate"] !== "" ||
          (value["percentage"] !== "" && value["percentage"] > 0))
      ) {
        lastReceiptAmount = value["toAmt"];
      } else {
        saveFlag = false;
      }
    });
    return saveFlag;
  };
  const deleteSelectedRow = (param) => {
    let toAmountValue = -1;
    let newRow = [];
    let count = 0;
    rows.forEach((data, index) => {
      if (param.id !== data.id) {
        if (data["fromAmt"] - 1 === toAmountValue) {
          toAmountValue = data["toAmt"];
        } else {
          data["fromAmt"] = toAmountValue + 1;
          toAmountValue = data["toAmt"];
        }
        data["id"] = count++;
        newRow.push(data);
      }
    });
    setRows(newRow);
  };
  const confirmationDialogOnOkHandler = async () => {
    try {
      const response = await axios.post(
        "/feestructuremaster/insertFeeStructure",
        {
          effectiveDate: new Date(effectiveDateValue).toLocaleDateString(
            "fr-FR"
          ),
          feeType: feeValue,
          product: productValue,
          constitutionType: constitutionType,
          branch: selectedBranchRows.map((record) => record.branch_name),
          feeStructureAmountModel: rows,
          applicationType: applicationType,
          proposalType: proposalType,
          loanType: loanType,
          profile: profile,
          purposeOfLoan: purposeofLoan,
          lifeCover: lifeCoverApplicability,
          rateType: rateType,
          borrowerCategory: borrowerCategory,
          loanCategory: loanCategory,
          propertyCategory: propertyCategory,
          type: type,
          gl: gl,
          subGl: subGL,
          createdBy: userName,
          lastModifiedBy: userName,
        }
      );
      if (response.status === 200) {
        setConfirmationDialogMode(false);
        setConfirmationDialogOpen(true);
        setConfirmationDialogMessage("Fee Definition Inserted successfully.");
      } else {
      }
    } catch (e) {}
  };
  const getGridData = async (value) => {
    const response = await axios.post("/feestructuremaster/getFeeStructure", {
      effectiveDate: new Date(effectiveDateValue).toLocaleDateString("fr-FR"),
      applicationType: applicationType,
      feeType: value,
    });
    if (response.status === 200) {
      response.data.branch.forEach((data) => {
        datarowsBranch.map((branch) => {
          if (branch.branch_name === data) {
            activeRowID.push(branch.id);
          }
        });
      });
      let branchArray = response.data.branch.map((data) => {
        return {
          branch_name: data,
        };
      });
      setSelectedBranchRows(branchArray);
      setSelectedRow(activeRowID);
      const responseWithID = response.data.feeStructureModel.map(
        (data, index) => {
          return {
            ...data,
            id: index,
          };
        }
      );
      setRows(responseWithID);
    } else {
    }
  };
  const saveButtonHandler = () => {
    if (doCheckIsDataValidated()) {
      setConfirmationDialogMode(true);
      setConfirmationDialogOpen(true);
      setConfirmationDialogMessage("Confirmation for Create ? ");
    } else {
      //   setInformationDialogMessage(
      //     "Range is not properly entered/Percentage or Flat Rate can't be 0"
      //   );
      //   setInformationDialogOpen(true);
    }
  };
  const getFee = async (value) => {
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL =
      process.env.REACT_APP_STLAP_LMS_FEE_DEFINITION;
    try {
      const responseData = await newAxiosBase.post(
        "/feestructuremaster/getFeeType",
        {
          effectiveDate: new Date(value).toLocaleDateString("fr-FR"),
          applicationType: applicationType,
        }
      );
      setFeeList(responseData.data);
    } catch (e) {}
  };
  return (
    <Box>
      <AccordianContainer
        title="Fee Rate Definition"
        initialOpen={true}
        sx={{ margin: "8px !important" }}
      >
        <Box sx={{ marginTop: "-1%" }}>
          <Grid container rowSpacing={0} columnSpacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Application"
                label="Application"
                required={true}
                value={applicationType}
                autoCompleteValues={applicationTypeList}
                onBlur={() => {
                  setApplicationTypeTouchHandler(true);
                }}
                onChange={(e, value) => {
                  setApplicationType(value);
                  setEffectiveDateValue(null);
                  feeTypeOnChangeHandler("");
                }}
              />
              {applicationTypeHasError && (
                <p className="error">Please Select Application Type</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomDateField
                type="date"
                label="Effective Date"
                variant="standard"
                required={true}
                disabled={
                  applicationType === null ||
                  applicationType === "" ||
                  applicationType === undefined
                }
                value={effectiveDateValue}
                onChange={(value) => {
                  effectiveDateOnChangeHandler(value);
                  setFeeTouchHandler(false);
                  getFee(value);
                }}
                onBlur={() => {
                  setEffectiveTouchHandler(true);
                }}
                minDate={new Date().setDate(
                  new Date().getDate() - minDateFromValue
                )}
                maxDate={new Date().setDate(
                  new Date().getDate() + maxDateFromValue
                )}
              ></CustomDateField>
              {effectiveDateHasError && (
                <p className="error">Please Select Effective Date</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Fee Type"
                label="Fee Type"
                required={effectiveDateIsValid}
                value={feeValue}
                disabled={
                  effectiveDateValue === null ||
                  effectiveDateValue === "" ||
                  applicationType === null ||
                  applicationType === "" ||
                  applicationType === undefined
                }
                autoCompleteValues={feeList}
                onBlur={() => {
                  setFeeTouchHandler(true);
                }}
                onChange={(e, value) => {
                  feeTypeOnChangeHandler(value);
                }}
              />
              {feeValueHasError && effectiveDateIsValid && (
                <p className="error">Please Select Fee Type</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Product Type"
                label="Product Type"
                required={true}
                value={productValue}
                autoCompleteValues={productList}
                onBlur={() => {
                  setProductTouchHandler(true);
                }}
                onChange={(e, value) => {
                  productOnChangeHandler(value);
                }}
              />
              {productHasError && (
                <p className="error">Please Select Product Type</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                variant="standard"
                type="text"
                placeholder="Select Constitution Type"
                label="Constitution Type"
                required={true}
                value={constitutionType}
                autoCompleteValues={["individual", "Non-individual"]}
                onBlur={() => {
                  setConstitutionTouchHandler(true);
                }}
                onChange={(e, value) => {
                  setConstitutionType(value);
                }}
              />
              {constitutionTypeHasError && (
                <p className="error">Please Select Constitution Type</p>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Proposal Type"
                variant="standard"
                disabled={true}
                value={proposalType}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Loan Type"
                variant="standard"
                disabled={true}
                value={loanType}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Profile"
                variant="standard"
                disabled={true}
                value={profile}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Purpose of Loan"
                variant="standard"
                disabled={true}
                value={purposeofLoan}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Life Cover Applicability"
                variant="standard"
                disabled={true}
                value={lifeCoverApplicability}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Rate Type"
                variant="standard"
                disabled={true}
                value={rateType}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Borrower Category"
                variant="standard"
                disabled={true}
                value={borrowerCategory}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Loan Category"
                variant="standard"
                disabled={true}
                value={loanCategory}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Property Category"
                variant="standard"
                disabled={true}
                value={propertyCategory}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Type"
                variant="standard"
                disabled={true}
                value={type}
              ></CustomTextField>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="GL"
                variant="standard"
                disabled={true}
                value={gl}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                type="text"
                label="Sub GL"
                variant="standard"
                disabled={true}
                value={subGL}
              ></CustomTextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2} xl={3}>
              <InputLabel
                required={true}
                size="small"
                sx={{
                  color: "#004A92",
                  mb: 2,
                  fontWeight: 400,
                  fontSize: "14px",
                }}
              >
                Select branch
              </InputLabel>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Select Branch">
                  <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-haspopup="true"
                    onClick={() => {
                      branchOnChangeHandler();
                    }}
                    disabled={
                      effectiveDateValue === null ||
                      effectiveDateValue === "" ||
                      feeValue === null ||
                      feeValue === ""
                    }
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>
                <p className="info">{selectedRow.length} Branch is Selected</p>
              </Box>
              {branchHasError && <p className="error">Please Select Branch</p>}
            </Grid>
          </Grid>
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "4px",
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              type="submit"
              sx={{ height: "2rem", fontWeight: "bold" }}
              onClick={goButtonHandler}
            >
              GO
            </Button>
            <Button
              sx={{
                color: "white",
                backgroundColor: "black",
                height: "2rem",
                fontWeight: "bold",
              }}
              onMouseOver={({ target }) => {
                target.style.backgroundColor = "black";
                target.style.color = "white";
              }}
              variant="contained"
              onClick={ClearButtonHandler}
            >
              Clear
            </Button>
          </Box>
        </Box>
      </AccordianContainer>
      <Dialog open={branchDialogOpen} maxWidth="sm" fullWidth>
        <DialogTitle>
          <h4>Select Branch</h4>
        </DialogTitle>
        <DialogContent>
          <div className={classes.dataGridContainer}>
            <DataGrid
              sx={{
                boxShadow: 2,
                border: 2,
                height: "320px",
                width: "100%",
                borderColor: "white",
                "& .MuiDataGrid-row:hover": {
                  color: "#004A92",
                  backgroundColor: "#B8E4F4",
                },
                "& .MuiDataGrid-columnHeaders": {
                  color: "white",

                  backgroundColor: "#004A92",
                },
              }}
              rows={datarowsBranch}
              columns={columnsBranchData}
              pageSize={10}
              headerHeight={48}
              rowHeight={52}
              pageSizeOptions={[10]}
              gridLazyLoad={() => {}}
              gridHeight={305}
              onCellKeyDown={(event, param) => {
                (param.key === "e" || param.key === "E") &&
                  param.preventDefault();
              }}
              checkboxSelection
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedBranchRows = datarowsBranch.filter((row) =>
                  selectedIDs.has(row.id)
                );
                setSelectedBranchRows(selectedBranchRows);
                setSelectedRow(ids);
              }}
              selectionModel={selectedRow}
              getRowClassName={(params) =>
                params.id % 2 ? `super-app-theme--even` : `super-app-theme--odd`
              }
              components={{ NoRowsOverlay, NoResultsOverlay }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setBranchDialogOpen(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      {displayDetail && (
        <Box
          sx={{
            color: "red",
            background: "white",
            padding: "0.8rem",
            borderRadius: "0.4rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "8px",
            }}
          >
            <Tooltip title="Add">
              <Button
                variant="contained"
                onClick={gridRowAddButtonHandler}
                sx={{
                  marginLeft: "1rem",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <AddIcon />
              </Button>
            </Tooltip>
            <Tooltip title="Save">
              <Button
                sx={{ fontWeight: "bold", marginLeft: "12px" }}
                variant="contained"
                onClick={saveButtonHandler}
                disabled={rows.length == 0}
              >
                <SaveIcon />
              </Button>
            </Tooltip>
          </Box>
          <CustomDataGrid
            noDataMessage="No Data."
            noDataOnFilterMessage="No Data on Applied Filter."
            rows={rows}
            columns={columnsData}
            pageSizeOptions={[5, 10, 15, 20, 25]}
            onCellEditCommit={(params) => {
              cellChangeHandler(params);
            }}
            onCellKeyDown={(params, event) => {
              (event.key === "e" ||
                event.key === "E" ||
                event.key.includes("-")) &&
                event.preventDefault();
            }}
            onRowClick={(params) => {
              if (
                (params.row.percentage === "" ||
                  params.row.percentage === null) &&
                (params.row.flatRate === "" || params.row.flatRate === null)
              ) {
                setPercentageEnable(true);
                setFlatEnable(true);
              } else if (
                (params.row.percentage === "" ||
                  params.row.percentage === null) &&
                (params.row.flatRate !== "" || params.row.flatRate !== null)
              ) {
                setPercentageEnable(false);
                setFlatEnable(true);
              } else if (
                (params.row.percentage !== "" ||
                  params.row.percentage !== null) &&
                (params.row.flatRate === "" || params.row.flatRate === null)
              ) {
                setPercentageEnable(true);
                setFlatEnable(false);
              }
            }}
            gridLazyLoad={() => {}}
            onSortModelChange={() => {}}
          />
        </Box>
      )}
      <Dialog
        open={confirmationDialogOpen}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {confirmationDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {confirmationDialogMode && (
            <>
              <Button
                onClick={() => {
                  setConfirmationDialogOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  confirmationDialogOnOkHandler();
                }}
              >
                Yes
              </Button>
            </>
          )}
          {!confirmationDialogMode && (
            <Button
              onClick={() => {
                window.location.reload();
              }}
            >
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default FeeRateDefinition;
